/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseAmountRespVo } from './DeliverFeeWarehouseAmountRespVo';
import {
    DeliverFeeWarehouseAmountRespVoFromJSON,
    DeliverFeeWarehouseAmountRespVoFromJSONTyped,
    DeliverFeeWarehouseAmountRespVoToJSON,
    DeliverFeeWarehouseAmountRespVoToJSONTyped,
} from './DeliverFeeWarehouseAmountRespVo';

/**
 * 
 * @export
 * @interface GradeFeeRespVo
 */
export interface GradeFeeRespVo {
    /**
     * 会员等级ID
     * @type {number}
     * @memberof GradeFeeRespVo
     */
    gradeId?: number;
    /**
     * 明细渲染模式：RANGE 区间明细
     * @type {string}
     * @memberof GradeFeeRespVo
     */
    ruleMode?: string;
    /**
     * 区间-金额明细
     * @type {Array<DeliverFeeWarehouseAmountRespVo>}
     * @memberof GradeFeeRespVo
     */
    ranges?: Array<DeliverFeeWarehouseAmountRespVo>;
}

/**
 * Check if a given object implements the GradeFeeRespVo interface.
 */
export function instanceOfGradeFeeRespVo(value: object): value is GradeFeeRespVo {
    return true;
}

export function GradeFeeRespVoFromJSON(json: any): GradeFeeRespVo {
    return GradeFeeRespVoFromJSONTyped(json, false);
}

export function GradeFeeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GradeFeeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'ruleMode': json['ruleMode'] == null ? undefined : json['ruleMode'],
        'ranges': json['ranges'] == null ? undefined : ((json['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoFromJSON)),
    };
}

export function GradeFeeRespVoToJSON(json: any): GradeFeeRespVo {
    return GradeFeeRespVoToJSONTyped(json, false);
}

export function GradeFeeRespVoToJSONTyped(value?: GradeFeeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'ruleMode': value['ruleMode'],
        'ranges': value['ranges'] == null ? undefined : ((value['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoToJSON)),
    };
}

